import { useQueries } from '@tanstack/react-query';

import { useMemo } from 'react';

import { InventoryListingStatus } from '@ekhodealer/ekho-common';

import type { InventoryItemSearchRecord} from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';

import { getInventoryItemQueryConfig } from './useGetInventoryItem';

const MAX_PREFETCH_COUNT = 15;

const NON_PUBLISHED_STATUSES = [
	InventoryListingStatus.INCOMPLETE_DRAFT,
	InventoryListingStatus.LOCKED,
];

/**
 * Prefetches full inventory item details for non-published items
 * so drawer data is ready when users open it
 */
export const usePrefetchUnpublishedInventory = (
	items: InventoryItemSearchRecord[],
	enabled = true,
) => {
	const currentServicesProviderId = useCurrentServicesProviderId();

	const itemsToPrefetch = useMemo(() => {
		if (!enabled) return [];

		return items
			.filter((item) => NON_PUBLISHED_STATUSES.includes(item.listing.status))
			.slice(0, MAX_PREFETCH_COUNT);
	}, [items, enabled]);

	return useQueries({
		queries: itemsToPrefetch.map((item) =>
			getInventoryItemQueryConfig(currentServicesProviderId, item.id, enabled),
		),
	});
};
